import { defineAsyncComponent, markRaw } from 'vue';

import { GLOBAL_MENUS } from '~coreModules/menu/js/menu-constants';

// eslint-disable-next-line import/prefer-default-export
export const MENUS = {
    ...GLOBAL_MENUS,
    editClosetListMenu: {
        modalTitle: 'sublist__drawer--title',
        component: markRaw(
            defineAsyncComponent(
                () => import(
                    /* webpackChunkName: "editClosetListMenu" */
                    '~routes/closet/components/EditClosetListMenu.vue'),
            ),
        ),
    },
    closetActionsMenu: {
        modalTitle: 'closet__drawer--title',
        component: markRaw(
            defineAsyncComponent(
                () => import(
                    /* webpackChunkName: "closetActionsMenu" */
                    '~routes/closet/components/ClosetActionsMenu.vue'),
            ),
        ),
    },
};
